import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPauseButton = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.36684 1.36683C6.24201 0.491665 7.42899 0 8.66667 0C9.90434 0 11.0913 0.491665 11.9665 1.36683C12.8417 2.242 13.3333 3.42899 13.3333 4.66667V27.3333C13.3333 28.571 12.8417 29.758 11.9665 30.6332C11.0913 31.5083 9.90434 32 8.66667 32C7.42899 32 6.24201 31.5083 5.36684 30.6332C4.49167 29.758 4 28.571 4 27.3333V4.66667C4 3.42899 4.49167 2.242 5.36684 1.36683ZM20.0338 1.36683C20.909 0.491665 22.096 0 23.3337 0C24.5713 0 25.7583 0.491665 26.6335 1.36683C27.5087 2.242 28.0003 3.42899 28.0003 4.66667V27.3333C28.0003 28.571 27.5087 29.758 26.6335 30.6332C25.7583 31.5083 24.5713 32 23.3337 32C22.096 32 20.909 31.5083 20.0338 30.6332C19.1587 29.758 18.667 28.571 18.667 27.3333V4.66667C18.667 3.42899 19.1587 2.242 20.0338 1.36683Z",
		fill: "white"
	})
});
export default SvgPauseButton;
